import { useDeviceType } from '@cian/ui-kit';
import * as styles from './styles.css';
import { clsx } from 'clsx';

interface IWrapperProps {
  children: JSX.Element[] | JSX.Element;
  withoutPaddingBottom?: boolean;
}

export const Wrapper: React.FC<IWrapperProps> = ({ children, withoutPaddingBottom = false }) => {
  const device = useDeviceType();

  return (
    <div
      className={clsx(styles['container'], styles[device], withoutPaddingBottom && styles['disabled-padding-bottom'])}
    >
      {children}
    </div>
  );
};
